import { Add } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";

import { IInvitationCreateDto } from "@framework/types";
import { Button } from "@dzambalaorg/ui-kit";
import { useGlobalDialogFormCallbacks } from "@framework/shared";

import { AdminDialogKeys } from "../../../../../shared";
import { managersInviteValidationSchema } from "./dialog/validation";

const emptyValues = {
  email: "",
};

export interface IInviteButtonProps {
  className?: string;
}

export const InviteButton = (props: IInviteButtonProps) => {
  const { className } = props;

  const { openDialog } = useGlobalDialogFormCallbacks<{ email: string }, IInvitationCreateDto>();

  const handleInvite = (): void => {
    openDialog(AdminDialogKeys.MANAGERS_INVITE, emptyValues, {
      initialValues: emptyValues,
      validationSchema: managersInviteValidationSchema,
      message: "dialogs.invite",
      testId: "InviteDialog",
      url: "/invitations",
    });
  };

  return (
    <Button
      intent="secondary"
      startIcon={<Add />}
      onClick={handleInvite}
      data-testid="InviteButton"
      className={className}
    >
      <FormattedMessage id="form.buttons.invite" />
    </Button>
  );
};
